// @ts-check
import Vue from 'vue';

import dictionary from './dictionary';
import schedule from '../schedule/schedule.json';

// @ts-ignore
import template from './template.html';
import './styles.scss';

const { APP_LANG } = process.env;
// const APP_LANG = 'ro';

export default Vue.component('bc-app', {
  template,

  data() {
    const showCookiesInfo = JSON.parse(localStorage.getItem('showCookiesInfo'));

    return {
      schedule: schedule[APP_LANG],
      shouldShowPopup: false,
      activeTab: 'weekdays',
      isHiddenOnMobile: true,
      currentSlideIndex: 0,
      showCookiesInfo: typeof showCookiesInfo === 'boolean'
        ? showCookiesInfo : true,
    };
  },

  methods: {
    t(key) {
      return dictionary[APP_LANG][key];
    },

    changeSlideIndex(difference) {
      const firstSlideIndex = 0;
      const lastSlideIndex = 4;

      this.currentSlideIndex = Math.max(
        firstSlideIndex,
        Math.min(this.currentSlideIndex + difference, lastSlideIndex),
      );
    },

    hideCookiesInfo() {
      this.showCookiesInfo = false;
      localStorage.setItem('showCookiesInfo', JSON.stringify(false));
    },
  },
});



// WEBPACK FOOTER //
// ./src/app/index.js